<template>
  <PDFViewer />
</template>

<script lang="ts" setup>
</script>
